import type { OperationLinkInput } from '../../model/operation-link.js';
import type { OperationLinkBodyDto } from '../dto/operation-link-body.dto.js';

export const toOperationLinkBody = (input: OperationLinkInput): OperationLinkBodyDto => ({
  occurrenceId: input.occurrenceId,
});
